import type { KeyboardEvent } from "react"

// Keyboard-equivalent of a click, for elements that act like a button but aren't a native
// <button> (e.g. a plain <a> with just an onClick, no href) - such elements need Enter/Space
// handling themselves, since the browser won't provide it for them.
const onEnterOrSpace = (onClick?: () => void) => (evt: KeyboardEvent) => {
  if (evt.key === "Enter" || evt.key === " ") {
    evt.preventDefault()
    onClick?.()
  }
}

export default onEnterOrSpace
